/*
 * @Date: 2021-08-12 14:59:36
 * @Description: 枚举
 */
export const SEARCH_HISTORY = 'SEARCH_HISTORY' // localStorage 搜索历史
export const USER_INFO = 'USER_INFO' // token


// WEBPACK FOOTER //
// ./pc/yiqijian-video/utils/enum.js